import { REPORT_RECEIVED, REPORT_UNLOADED } from './types'
import api from 'api'

export const reportReceived = data => ({
  type: REPORT_RECEIVED,
  data
})

export const reportUnload = () => ({
  type: REPORT_UNLOADED
})

export const unloadReport = () => dispatch => {
  dispatch(reportUnload())
}

export const getReport = (type, planid) => dispatch =>
  api.bmc.report.getReport(type, planid).then( data => {
    dispatch(reportReceived(data))
  })

export const getComparePlans = (type) => dispatch =>
  api.bmc.report.getComparePlans(type).then( data => {
  dispatch(reportReceived(data))
})

export const getExcel = (type, planid) => dispatch =>
  api.bmc.report.getExcel(type, planid).then( data => {
  dispatch(reportReceived(data))
})

export const allocateSurplus = data => dispatch =>
  api.bmc.report.allocateSurplus(data).then( () => {
    dispatch(getReport())
  })

export const postReportActivity = data => dispatch => api.bmc.activities.postActivity(data)